import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CarModel, UserModel } from './models';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }

  sendCotizacion(params: any) {
    return this.http.post<any>(environment.apiSV + 'cotizadores/send', params);
  }

  getCotizadores() {
    return this.http.get<any>(environment.apiSV + 'cotizadores');
  }

  getCotizador(code: string) {
    return this.http.get<any>(environment.apiSV + 'cotizadores/' + code);
  }

  getProductosCotizador(cotizadorId: number) {
    return this.http.get<any>(environment.apiSV + 'cotizadores/' + cotizadorId + '/productos');
  }

  getProductosRecomendados(cotizadorId: number, sa: number) {
    return this.http.get<any>(environment.apiSV + 'productos/recomendados/' + cotizadorId + '/' + sa);
  }

  getProductosRecomendados1(cotizadorId: number, sa: number, params: any = {}) {

    let p = new URLSearchParams();
    for (let key in params) {
      p.set(key, params[key])
    }

    return this.http.get<any>(environment.apiSV + 'productos/recomendados1/' + cotizadorId + '/' + sa + '?' + p);
  }

  getProductosRecomendadosByCobertura(coberturaId: number, sa: number, params: any = {}) {

    let p = new URLSearchParams();
    for (let key in params) {
      p.set(key, params[key])
    }

    return this.http.get<any>(environment.apiSV + 'productos/recomendadosByCobertura/' + coberturaId + '/' + sa + '?' + p);
  }

  getProductosRecomendadosById(coberturaId: number, sa: any, params: any = {}) {

    let p = new URLSearchParams();
    for (let key in params) {
      p.set(key, params[key])
    }

    return this.http.get<any>(environment.apiSV + 'productos/recomendadosById/' + coberturaId + '/' + sa + '?' + p);
  }

  getProductosRecomendadosBySa(coberturaId: number, sa: number, params: any = {}) {

    let p = new URLSearchParams();
    for (let key in params) {
      p.set(key, params[key])
    }

    return this.http.get<any>(environment.apiSV + 'productos/recomendadosBySa/' + coberturaId + '/' + sa + '?' + p);
  }

  getProductosRecomendadosByMetros(cotizadorId: number, metros: number, provinciaId: number) {
    return this.http.get<any>(environment.apiSV + 'productos/recomendadosByMetros/' + cotizadorId + '/' + metros + '/' + provinciaId);
  }

  getCoberturasCotizador(cotizadorId: number) {
    return this.http.get<any>(environment.apiSV + 'cotizadores/' + cotizadorId + '/coberturas');
  }

  getCoberturasTopes(coberturaId: number) {
    return this.http.get<any>(environment.apiSV + 'coberturas/' + coberturaId + '/topes');
  }

  updateCoberturasCotizador(params: any) {
    return this.http.post<any>(environment.apiSV + 'cotizadores/coberturas_x_productos', params);
  }

  updateLead(params: any) {
    return this.http.post<any>(environment.apiSV + 'cotizadores/lead', params);
  }

  getHorariosCC() {
    return this.http.get<any>(environment.apiSV + 'horarioscc');
  }

  getFechasDisclaimer() {
    return this.http.get<any>(environment.apiSV + 'disclaimer_fechas');
  }

  getCardBrands() {
    return this.http.get<any>(environment.api123 + 'auto/resources/marcas');
  }

  getCardYears(brand_id: any) {
    return this.http.get<any>(environment.api123 + 'auto/resources/marcas/' + brand_id + '/anios');
  }

  getCardFamilies(brand_id: any, year: any) {
    return this.http.get<any>(environment.api123 + 'auto/resources/marcas/' + brand_id + '/anios/' + year + '/versiones')
  }

  getCardModels(brand_id: any, year: any, family_id: any) {
    return this.http.get<any>(environment.api123 + 'auto/resources/marcas/' + brand_id + '/anios/' + year + '/versiones/' + family_id + '/modelos')
  }

  getProvinces() {
    return this.http.get<any>(environment.api123 + 'auto/resources/provincias');
  }

  getLocalities(province_id: any) {
    return this.http.get<any>(environment.api123 + 'auto/resources/provincias/' + province_id + '/localidades');
  }

  getCanales() {
    return this.http.get<any>(environment.api123 + 'auto/resources/canales');
  }

  getCompanies() {
    return this.http.get<any>(environment.api123 + 'auto/resources/companias');
  }

  getCoveragesByCompany(companyId: number) {
    return this.http.get<any>(environment.api123 + 'auto/resources/companias/' + companyId + '/coberturas');
  }

  getCoverages() {
    return this.http.get<any>(environment.api123 + 'auto/resources/coberturas');
  }


  getQuotes(companyName: string, productId: number) {
    return this.http.get<any>(environment.api123 + 'auto/cotizar/' + companyName + '?producto_id=' + productId);
  }

  addUser(params: any) {
    return this.http.post<any>(environment.api123 + 'auto/resources/usuarios', params);
  }

  addCar(car: CarModel, user_id: any, channel_id: any) {

    let params = {
      vehiculo_id: car.model_id,
      anio: car.year,
      canal_id: channel_id
    }

    return this.http.post<any>(environment.api123 + 'auto/resources/usuarios/' + user_id + '/autos', params);
  }


  addAddress(user_id: any, localityId: any) {
    let params = {
      localidad_id: localityId
    }
    return this.http.post<any>(environment.api123 + 'auto/resources/usuarios/' + user_id + '/direcciones', params);
  }


  updateCar(car: CarModel, user_id: any, car_id: any) {

    let params = {
      vehiculo_id: car.model_id,
      anio: car.year
    }

    return this.http.put<any>(environment.api123 + 'auto/resources/usuarios/' + user_id + '/autos/' + car_id, params);
    //return this.http.post<any>(environment.api123 + 'auto/resources/usuarios/' + user_id + '/autos/' + car_id, params);

  }

  getToken() {
    return this.http.get<any>(environment.oauth123);
  }

  //MASCOTAS
  getRazas(tipo: string) {
    return this.http.get<any>(environment.apiSV + 'razas/' + tipo);
  }

  //PROVINCIAS
  getProvincias() {
    return this.http.get<any>(environment.apiSV + 'provincias');
  }

  //OCUPACIONES
  getOcupaciones() {
    return this.http.get<any>(environment.apiSV + 'ocupaciones');
  }

  //NACIONALIDADES
  getNacionalidades() {
    return this.http.get<any>(environment.apiSV + 'nacionalidades');
  }

}
